import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { macroExamService } from 'shared/services';
import MacroExamForm from '../components/MacroExamForm';
import { IMacroExam } from '../types';
import toast from 'shared/utils/toast';

const initMacroExam: IMacroExam = {
  id: null,
  code: null,
  description: null
};

export const CreateMacroExam = () => {
  const translationPrefix = 'pages.macro-exams.new';
  const { t } = useTranslation();
  const navigate = useNavigate();

  const createMacroExam = async (values) => {
    macroExamService.add(values).then((res) => {
      toast.crud.successCreate('Macro-esame');
      if (res?.id) {
        navigate(`../${res.id}`);
      }
    });
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <MacroExamForm macroExam={initMacroExam} onSubmit={createMacroExam} />
    </TenantPage>
  );
};

export default CreateMacroExam;
